import { render, staticRenderFns } from "./BrigadeMapTasksList.vue?vue&type=template&id=1d9e196b&scoped=true&"
import script from "./BrigadeMapTasksList.vue?vue&type=script&lang=js&"
export * from "./BrigadeMapTasksList.vue?vue&type=script&lang=js&"
import style0 from "./BrigadeMapTasksList.vue?vue&type=style&index=0&id=1d9e196b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9e196b",
  null
  
)

export default component.exports
import {QIcon,QSeparator,QBtn,QSpinnerDots} from 'quasar'
component.options.components = Object.assign({QIcon,QSeparator,QBtn,QSpinnerDots}, component.options.components || {})
